import { render, staticRenderFns } from "./ServerSearchResult.vue?vue&type=template&id=7688730c&scoped=true"
import script from "./ServerSearchResult.vue?vue&type=script&lang=js"
export * from "./ServerSearchResult.vue?vue&type=script&lang=js"
import style0 from "./ServerSearchResult.vue?vue&type=style&index=0&id=7688730c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688730c",
  null
  
)

export default component.exports